<mat-card class="card">
    <ng-content select="[image]"></ng-content>
    <mat-card-header class="header">
        <mat-card-title>
            <div class="title">
                <ng-content select="[title]"></ng-content>
                <div class="toggle-button">
                    <button mat-icon-button aria-label="Expand/collapse" (click)="toggleContent()">
                        <mat-icon>{{ showContent ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </button>
                </div>
            </div>
        </mat-card-title>
        <mat-card-subtitle class="subtitle">
            <ng-content select="[subtitle]"></ng-content>
        </mat-card-subtitle>
    </mat-card-header>
    <div class="expandable-container" [class.collapsed]="!showContent">
        <mat-card-content class="content">
            <ng-content select="[content]"></ng-content>
        </mat-card-content>
    </div>
</mat-card>
